import { userActionTypes } from "./user.types";
const INITIAL_STATE = {
  currentUser: null,
  isAuth: false,
};

const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case userActionTypes.SET_CURRENT_USER:
      console.log("🧨 REDUX USER SET:", action.payload);
      return {
        ...state,
        currentUser: action.payload,
        isAuth: action.payload ? true : false,
      };
    default:
      return state;
  }
};

export default userReducer;
